function sectionRedering() {
  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__main-wrap", cart__html);
      $(".cart-drawer__main-wrap").replaceWith(render__html);

      var render__html = $(".cart-drawer__top-text em", cart__html);
      $(".cart-drawer__top-text em").replaceWith(render__html);
      cartSlider();
    });

  // header 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart p", cart__html);
      $(".header__cart p").replaceWith(render__html);
    });

}


function cartSlider() {
  $('.cart-drawer__slider-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  });

}


// $(".explore__add-to-cart").on("click", function (event) {
//   event.preventDefault(); // Stop default action
//   var variantId = $(this).attr('data-product-id');

//   var data = {
//     id: variantId,
//     quantity: 1
//   };


//   $.ajax({
//     type: "POST",
//     url: "/cart/add.js",
//     data: data,
//     dataType: "json",
//     success: function (response) {
//       $("body").addClass("cart-open");
//       sectionRedering();
//     },
//     error: function (err) {
//       console.log("Error adding product to cart:", err);
//     }
//   });
// })



// increment quantity in cart drawer
function increment(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrement(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRedering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}


function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };

  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {

      sectionRedering();
    }
  })
}




function updateVariantImage(variant_featured_img) {
  if (variant_featured_img) {
    $(".main-product__big-item").each(function () {
      let img__src = $(this).find("img").attr("src");
      if (variant_featured_img === img__src) {
        let index = $(this).closest(".main-product__big-item").attr("data-slick-index");
        $('.main-product__big-items').slick('slickGoTo', index);
      }

    })
  }
}


// match variant and update variant id and variant image 
// $(document).ready(function () { 
function selectedVarint() {
  var slectedId = $(".select__variant").val();
  var url = new URL(window.location.href);
  url.searchParams.set("variant", slectedId);
  window.history.replaceState({}, "", url);
}


//   // match variant

function matchVariant() {
  var updateValue = "";
  $(".main-product__flavour-item input[type='radio']:checked").each(function () {

    updateValue += (updateValue ? " / " : "") + $(this).val();
  })

  var isMatchFound = false;
  $(".select__variant option").each(function () {

    var optionValue = $(this).text().trim();

    if (updateValue.toLowerCase() == optionValue.toLowerCase()) {
      isMatchFound = true;
      $(this).prop("selected", true);


      var variant__available = $(this).attr("data-variant-available");

      // var variant_featured_img = $(this).attr("data-variant-featured-img");
      $(".main-product__flavour h6 em").text(optionValue);
      // call update variant image function 
      // updateVariantImage(variant_featured_img);
      if (variant__available == 'false') {
        $(".main-product-btn-add").addClass("disabled");
      } else {
        $(".main-product-btn-add").removeClass("disabled");

      }
    }
    return true;

  });
}

$(".main-product__flavour-item input[type='radio']").change(function () {
  matchVariant();
  selectedVarint();
})
$(document).ready(function () {
  matchVariant();
});


$(".main-product-btn-add").on("click", function (e) {
  e.preventDefault();
  formData = $(this).closest(".single__product-add-pro").serialize();
  addToCart(formData)
});

$(".sticky-atc__add").on("click", function (e) {
  e.preventDefault();
  formData = $(".single__product-add-pro").serialize();
  addToCart(formData)
})

$(".product-card__btn-add").on("click", function (e) {
  e.preventDefault();
  formData = $(this).parent().parent().find(".card-product").serialize();
  addToCart(formData)
});



function addToCart(formData) {
  console.log(formData);
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: formData,
    success: function (data) {
      console.log(data)
      $("body").addClass("cart-open");
      sectionRedering();

    },
    error: function (err) {
      console.log(err);
    },
  });
};






function increment_p(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
}

function decrement_p(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 1) {
    value = isNaN(value) ? 1 : value;
    value--;
    input.value = value;


  }
}


$(".main-product__select-unselect, #selling_plan").on("change", function () {
  const isSubscribed = $("#subscribe").is(":checked");
  
  // var price_per_drink = $('.variant__input:checked').attr("price_per_drink");
  // var sub_price_per_drink = $('.variant__input:checked').attr("sub_price_per_drink");

  if (isSubscribed) {
    $(".selling__plan-set-value").attr("name", "selling_plan");
    $('.main-product__deli-text').show();

    const selectedPlanId = $("#selling_plan").val();
    $(".selling__plan-set-value").val(selectedPlanId);

    $('.variant__input').each(function(){
      var sub_price_per_drink = $(this).attr("sub_price_per_drink");
      $(this).parent().find('.variant__price-per-drink span').text(sub_price_per_drink);
    })

  } else {
    $(".selling__plan-set-value").attr("name", "").val("");
    $('.main-product__deli-text').hide();

    $('.variant__input').each(function(){
      var price_per_drink = $(this).attr("price_per_drink");
      $(this).parent().find('.variant__price-per-drink span').text(price_per_drink);
    })
  }
});


$(".variant__input").on("change", function () {
  var price = $(this).attr("price");
  var sub_price = $(this).attr("sub_price");
  var available = $(this).attr("available");

  if (available == 'false') {
    $(".main-product-btn-add").addClass("disabled");
    $('.main-product-btn-add').text('Sold Out');
  } else {
    $(".main-product-btn-add").removeClass("disabled");
    $('.main-product-btn-add').text('Add to Cart');
  }
  
  $('.selling-sub .main-product__title-right p').text(sub_price);
  $('.main-product__title-right del').text(price);
  $('.selling-one .main-product__title-right p').text(price);
});


function isOutOfViewport($el) {
  const rect = $el[0].getBoundingClientRect();
  const windowHeight = $(window).height();
  const windowWidth = $(window).width();

  // Check if completely outside viewport
  return (
    rect.bottom < 0 || // Above
    rect.top > windowHeight || // Below
    rect.right < 0 || // Left
    rect.left > windowWidth // Right
  );
}

$(window).on('scroll resize load', function () {
  const $el = $('.main-product__wrap');

  if ($el.length && isOutOfViewport($el)) {
    $('.sticky-atc').fadeIn();
  } else {
    $('.sticky-atc').fadeOut();
  }
});



function addToCartDrawer(event,$this) {

  event.preventDefault(); // Stop default action
  var variantId = $($this).attr('data-product-id');
  console.log(variantId);
  var data = {
    id: variantId,
    quantity: 1
  };


  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function (response) {
      sectionRedering();
    },
    error: function (err) {
      console.log("Error adding product to cart:", err);
    }
  });

}







// function subscriptionProductAdd(event, el) {
//   event.preventDefault();

//   const $el = $(el);
//   const lineKey = $el.attr('data-line-key');
//   const sellingPlanId = $el.attr('data-selling-plan');

//   if (!lineKey || !sellingPlanId) {
//     console.error('Missing line key or selling plan id');
//     return;
//   }

//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     data: {
//       id: lineKey,     
//       quantity: 1,  
//       selling_plan: sellingPlanId
//     },
//     dataType: "json",
//     success: function (response) {
//       console.log('Converted to subscription:', response);
    
//       sectionRedering();
//     },
//     error: function (err) {
//       console.error("Error converting to subscription:", err);
//     }
//   });
// }


function subscriptionPlanChanged(selectEl) {
  const $el = $(selectEl);
  const lineKey = $el.data('line-key');     
  const sellingPlanId = $el.val();
  const item_qty = $(selectEl).parent().prev().find('.cart-drawer__quan-inp').val();

  if (!lineKey || !sellingPlanId) {
    console.error('Missing line key or selling plan id');
    return;
  }
  console.log(item_qty);
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    data: {
      id: lineKey,            
      quantity: item_qty,            
      selling_plan: sellingPlanId 
    },
    dataType: "json",
    success: function (response) {
      console.log('Subscription plan changed:', response);
      
      sectionRedering();
    },
    error: function (err) {
      console.error("Error changing subscription plan:", err);
    }
  });
}






function subscriptionOptionShow(event, el) {
  event.preventDefault();

  $(el).hide();
  $(el).next('.cart-drawer__selling-plan-select').show();
}







// function subscriptionPlanClicked(selectEl) {
//   const $select = $(selectEl);
//   const lineKey = $select.data('line-key');
//   const sellingPlanId = $select.val();

//   if (!lineKey || !sellingPlanId) {
//     console.error('Missing line key or selling plan id');
//     return;
//   }

//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     data: {
//       id: lineKey,
//       quantity: 1,
//       selling_plan: sellingPlanId
//     },
//     dataType: "json",
//     success: function (response) {
//       console.log('Subscription plan changed:', response);
//       sectionRedering();
//     },
//     error: function (err) {
//       console.error("Error changing subscription plan:", err);
//     }
//   });
// }























cartSlider();